import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: 'content-mode-control-btns'
}
const _hoisted_2 = {
  id: 'openapi-info',
  ref: "openApiInfo"
}
const _hoisted_3 = {
  id: 'info-header',
  class: "info-header"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" OpenAPI: ")
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" URL: ")
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "auth-wrapper"
}
const _hoisted_13 = {
  key: 0,
  class: "btn rest-unauthorize-btn"
}
const _hoisted_14 = { class: "rest-unauthorize-caption" }
const _hoisted_15 = {
  class: "rest-unauthorize-form",
  id: 'rest-unauthorize-form'
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 1,
  class: "btn rest-authorize-btn"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "rest-authorize-caption" }, "Authorize", -1)
const _hoisted_19 = {
  key: 0,
  class: "rest-authorize-error"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Wrong username or password", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "field-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  class: "field-caption",
  for: "rest-login"
}, "Login", -1)
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "field-group" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  class: "field-caption",
  for: "rest-password"
}, "Password", -1)
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { ref: "openApiUI" }
const _hoisted_31 = {
  key: 0,
  id: 'openapi-ui',
  class: "swagger-ui"
}
const _hoisted_32 = { class: "information-container wrapper" }
const _hoisted_33 = { class: "block col-12" }
const _hoisted_34 = { class: "info" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h2", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" Title "),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("small", null, [
      /*#__PURE__*/_createElementVNode("pre", { class: "version" }, "1.0.0")
    ]),
    /*#__PURE__*/_createElementVNode("small", { class: "version-stamp" }, [
      /*#__PURE__*/_createElementVNode("pre", { class: "version" }, "OAS3")
    ])
  ])
], -1)
const _hoisted_36 = { class: "description" }
const _hoisted_37 = { class: "renderedMarkdown" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "wrapper" }
const _hoisted_41 = { class: "block col-12 block-desktop col-12-desktop" }
const _hoisted_42 = { class: "opblock-tag-section is-open" }
const _hoisted_43 = { style: {"height":"auto","border":"none","margin":"0px","padding":"0px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hgroup = _resolveComponent("hgroup")!
  const _component_openapi_operation = _resolveComponent("openapi-operation")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.canEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.editorMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-warning editor-mode-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleEditorMode('off')))
              }))
            : _createCommentVNode("", true),
          (!_ctx.editorMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-outline-success view-mode-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleEditorMode('on')))
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, [
        (_ctx.editorMode)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass({
						empty: !_ctx.model.openApiDocument.info.title,
						'editable-field': _ctx.model.allowEditServiceShortDescr
					}),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editServiceName()))
            }, _toDisplayString(_ctx.model.openApiDocument.info.title ||
						(_ctx.model.allowEditServiceShortDescr ? "Add service name..." : "")), 3))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.model.openApiDocument.info.title || ""), 1)),
        _createElementVNode("span", null, "(" + _toDisplayString(_ctx.model.serviceCode) + ")", 1)
      ]),
      (Object.keys(_ctx.model.openApiDocument.paths).length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("p", null, [
              _hoisted_5,
              _createElementVNode("a", {
                class: "openapi-info__spec_url",
                href: _ctx.model.openApiSpecPath,
                target: "_blank"
              }, _toDisplayString(_ctx.model.openApiSpecPath), 9, _hoisted_6),
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(`${_ctx.$t("apiDoc.openApi.version")} : ${
							_ctx.model.openApiDocument.info.version
						}`), 1),
              _hoisted_8,
              (_ctx.showExecutorUI)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_9,
                    _createElementVNode("a", {
                      class: "openapi-info__service_url",
                      href: _ctx.model.serviceEndpointUrl,
                      target: "_blank"
                    }, _toDisplayString(_ctx.model.serviceEndpointUrl), 9, _hoisted_10),
                    _hoisted_11
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.editorMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.showExecutorUI)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, "User: " + _toDisplayString(_ctx.restAuth.restLogin), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("button", {
                            class: "btn btn-outline-secondary rest-logout-btn",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.unauthorize && _ctx.unauthorize(...args))),
                            disabled: _ctx.restAuth.inProgress
                          }, " Logout ", 8, _hoisted_16)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("form", {
                          class: "rest-authorize-form",
                          id: 'rest-authorize-form',
                          name: "restloginform",
                          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.authorize && _ctx.authorize(...args)), ["prevent"]))
                        }, [
                          (_ctx.restAuth.failed)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.restAuth.restLoginInput) = $event)),
                              autocomplete: "rest-login",
                              type: "text",
                              maxlength: "255",
                              name: "rest-login",
                              id: 'rest-login',
                              disabled: _ctx.restAuth.inProgress
                            }, null, 8, _hoisted_24), [
                              [_vModelText, _ctx.restAuth.restLoginInput]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.restAuth.restPasswordInput) = $event)),
                              autocomplete: "rest-password",
                              type: "password",
                              maxlength: "255",
                              name: "rest-password",
                              id: 'rest-password',
                              disabled: _ctx.restAuth.inProgress
                            }, null, 8, _hoisted_27), [
                              [_vModelText, _ctx.restAuth.restPasswordInput]
                            ])
                          ]),
                          _createElementVNode("button", {
                            class: "btn btn-outline-secondary rest-login-btn",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.authorize && _ctx.authorize(...args))),
                            disabled: _ctx.restAuth.inProgress
                          }, " Login ", 8, _hoisted_28)
                        ], 32)
                      ]))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("p", _hoisted_29, "'Wadl file does not exist'"))
    ], 512),
    _createElementVNode("div", _hoisted_30, [
      (Object.keys(_ctx.model.openApiDocument.paths).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("section", _hoisted_33, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_hgroup, { class: "main d-none" }, {
                        default: _withCtx(() => [
                          _hoisted_35
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          (_ctx.editorMode)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["editable-field", {
													empty: !_ctx.model.openApiDocument.info.description
												}]),
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.editServiceDescription())),
                                innerHTML: _ctx.sanitize(_ctx.model.openApiDocument.info.description || 'Add service description...')
                              }, null, 10, _hoisted_38))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                innerHTML: _ctx.sanitize(_ctx.model.openApiDocument.info.description || '')
                              }, null, 8, _hoisted_39))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("section", _hoisted_41, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operations, (operationProp) => {
                            return (_openBlock(), _createBlock(_component_openapi_operation, _mergeProps(operationProp, {
                              key: 
													operationProp.pathKey +
													'_' +
													operationProp.operationKey
												
                            }), null, 16))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}